export default {
  trade: 'Trade',
  financialAndEconomicServices: 'Financial and Economic Services',
  accountingAuditingTaxConsultingAndFinancialServices:
    'Accounting, Auditing, Tax Consulting and Financial Services',
  humanResourcesPerformanceEvaluation: 'Human Resources Performance Evaluation',
  goldTrading: 'Gold Trading',
  digitalCurrency: 'Digital Currency',
  tradeCard: 'Trade Card',
  financialSystem: 'Financial System',
  investmentConsulting: 'Investment Consulting',
  insuranceAgency: 'Insurance Agency',
  insuranceCompany: 'Insurance Company',
  officialBooksSealing: 'Official Books Sealing',
  safeSale: 'Safe Sale',
  managementAndFinancialSystemDesignAndImplementation:
    'Management and Financial System Design and Implementation',
  leasing: 'Leasing',
  other: 'Other',
  tradeServices: 'Trade Services',
  digitalMarketing: 'Digital Marketing',
  goodsCustomsClearance: 'Goods Customs Clearance',
  goodsDistribution: 'Goods Distribution',
  tradeConsulting: 'Trade Consulting',
  chamberOfCommerce: 'Chamber of Commerce',
  goodsInspection: 'Goods Inspection',
  foreignCompanyRepresentativeOffice: 'Foreign Company Representative Office',
  managementConsulting: 'Management Consulting',
  customs: 'Customs',
  importAndExport: 'Import and Export',
  crystalAndCrystalWareImportExport: 'Crystal and Crystal Ware Import/Export',
  carImport: 'Car Import',
  autoSparePartsImportExport: 'Auto Spare Parts Import/Export',
  rimAndTireImportExport: 'Rim and Tire Import/Export',
  motorcycleSparePartsImport: 'Motorcycle Spare Parts Import',
  leatherAndSalamoorImportExport: 'Leather and Salamoor Import/Export',
  flowerAndPlantImportExport: 'Flower and Plant Import/Export',
  fruitAndVegetableImportExport: 'Fruit and Vegetable Import/Export',
  nutAndDriedFruitImportExport: 'Nut and Dried Fruit Import/Export',
  foodStuffImportExport: 'Foodstuff Import/Export',
  fabricImportExport: 'Fabric Import/Export',
  clothingImportExport: 'Clothing Import/Export',
  carpetAndRugExport: 'Carpet and Rug Export',
  paperAndCardboardImportExport: 'Paper and Cardboard Import/Export',
  eyeglassesImport: 'Eyeglasses Import',
  medicalEquipmentImport: 'Medical Equipment Import',
  dentalEquipmentImport: 'Dental Equipment Import',
  chemicalSubstancesImportExport: 'Chemical Substances Import/Export',
  medicineImport: 'Medicine Import',
  cosmeticAndHygienicProductsImportExport:
    'Cosmetic and Hygienic Products Import/Export',
  sportsEquipmentImport: 'Sports Equipment Import',
  bearingAndOilSealImport: 'Bearing and Oil Seal Import',
  adhesiveImportExport: 'Adhesive Import/Export',
  filterPaperImport: 'Filter Paper Import',
  agriculturalProductsImport: 'Agricultural Products Import',
  dateExport: 'Date Export',
  watchImport: 'Watch Import',
  goodsImportExport: 'Goods Import/Export',
  toyImport: 'Toy Import',
  industryImportExport: 'Industry Import/Export',
  oilGasAndPetrochemicalRefineryEquipmentImport:
    'Oil, Gas and Petrochemical Refinery Equipment Import',
  industrialToolsImportExport: 'Industrial Tools Import/Export',
  oilGasAndPetrochemicalProductsImportExport:
    'Oil, Gas and Petrochemical Products Import/Export',
  ironImportExport: 'Iron Import/Export',
  screwNutAndNailAndRivetImportExport:
    'Screw, Nut, Nail and Rivet Import/Export',
  glassAndMirrorImportExport: 'Glass and Mirror Import/Export',
  telecommunicationsAndWireAndCablePartsImportExport:
    'Telecommunications and Wire & Cable Parts Import/Export',
  industrialAndAgriculturalMachineryImport:
    'Industrial and Agricultural Machinery Import',
  agriculturalAndGardeningSeedsSaleAndImport:
    'Agricultural and Gardening Seeds Sale and Import',
  toolsAndFittingsImportExport: 'Tools and Fittings Import/Export',
  laboratoryMaterialsImport: 'Laboratory Materials Import',
  filterImportExport: 'Filter Import/Export',
  craneImport: 'Crane Import',
  constructionMachineryImport: 'Construction Machinery Import',
  agriculturalAndLivestockMachineryImport:
    'Agricultural and Livestock Machinery Import',
  buildingImportExport: 'Building Import/Export',
  tileAndCeramicImportExport: 'Tile and Ceramic Import/Export',
  faucetAndFittingsImportExport: 'Faucet and Fittings Import/Export',
  householdAppliancesImport: 'Household Appliances Import',
  buildingAndDecorativeStoneImportExport:
    'Building and Decorative Stone Import/Export',
  cabinetEquipmentImportExport: 'Cabinet Equipment Import/Export',
  buildingSanitarySuppliesImportExport:
    'Building Sanitary Supplies Import/Export',
  constructionToolsImportExport: 'Construction Tools Import/Export',
  lockAndKeyImport: 'Lock and Key Import',
  constructionMaterialImportExport: 'Construction Material Import/Export',
  electronicsSuppliesImportExport: 'Electronics Supplies Import/Export',
  electricalSuppliesImportExport: 'Electrical Supplies Import/Export',
  computerPeripheralsImport: 'Computer Peripherals Import',
  officeMachineryImport: 'Office Machinery Import',
  mobilePhoneImport: 'Mobile Phone Import',
  monitorImport: 'Monitor Import',
  electronicComponentsImportExport: 'Electronic Components Import/Export',
  electronicEquipmentImportExport: 'Electronic Equipment Import/Export',
  computerHardwareComponentsImport: 'Computer Hardware Components Import',
  networkEquipmentImport: 'Network Equipment Import',
  medicalAndHealth: 'Medical and Health',
  specialistPhysician: 'Specialist Physician',
  cardiologist: 'Cardiologist',
  diabetologist: 'Diabetologist',
  rhinoplastySurgeon: 'Rhinoplasty Surgeon',
  medicalGenetics: 'Medical Genetics',
  pulmonaryFunctionTest: 'Pulmonary Function Test',
  obstetricianAndGynecologist: 'Obstetrician and Gynecologist',
  otorhinolaryngologist: 'Otorhinolaryngologist',
  dermatologist: 'Dermatologist',
  nutritionist: 'Nutritionist',
  generalSurgeon: 'General Surgeon',
  neurosurgeon: 'Neurosurgeon',
  psychiatrist: 'Psychiatrist',
  neurologist: 'Neurologist',
  generalPractitioner: 'General Practitioner',
  clinicalPsychologist: 'Clinical Psychologist',
  familyPhysician: 'Family Physician',
  ophthalmologist: 'Ophthalmologist',
  midwifery: 'Midwifery',
  orthopedicSurgeon: 'Orthopedic Surgeon',
  urologist: 'Urologist',
  chiropractor: 'Chiropractor',
  allergist: 'Allergist',
  infectiousDiseaseSpecialist: 'Infectious Disease Specialist',
  pathologist: 'Pathologist',
  clinicalPathologist: 'Clinical Pathologist',
  anesthesiologist: 'Anesthesiologist',
  reproductiveBiologySpecialist: 'Reproductive Biology Specialist',
  forensicMedicineSpecialist: 'Forensic Medicine Specialist',
  nuclearMedicineSpecialist: 'Nuclear Medicine Specialist',
  internist: 'Internist',
  radiotherapist: 'Radiotherapist',
  radiologist: 'Radiologist',
  molecularGeneticist: 'Molecular Geneticist',
  rehabilitationSpecialist: 'Rehabilitation Specialist',
  laboratorySciencesSpecialist: 'Laboratory Sciences Specialist',
  homeopath: 'Homeopath',
  socialMedicineAndPreventiveMedicineSpecialist:
    'Social Medicine and Preventive Medicine Specialist',
  psychometrist: 'Psychometrist',
  endocrinologistAndMetabolismSpecialist:
    'Endocrinologist and Metabolism Specialist',
  subspecialistPhysician: 'Subspecialist Physician',
  cardiologySubspecialist: 'Cardiology Subspecialist',
  interventionalCardiologySubspecialist:
    'Interventional Cardiology Subspecialist',
  angioplastyAndValvuloplastySubspecialist:
    'Angioplasty and Valvuloplasty Subspecialist',
  pulmonologySubspecialist: 'Pulmonology Subspecialist',
  endocrinologyAndMetabolismSubspecialist:
    'Endocrinology and Metabolism Subspecialist',
  nephrologySubspecialist: 'Nephrology Subspecialist',
  gastroenterologySubspecialist: 'Gastroenterology Subspecialist',
  painSubspecialist: 'Pain Subspecialist',
  hematologyAndOncologySubspecialist: 'Hematology and Oncology Subspecialist',
  spineSubspecialist: 'Spine Subspecialist',
  shoulderSubspecialist: 'Shoulder Subspecialist',
  boneAndJointSubspecialist: 'Bone and Joint Subspecialist',
  ankleSubspecialist: 'Ankle Subspecialist',
  kneeSubspecialist: 'Knee Subspecialist',
  infertilitySubspecialist: 'Infertility Subspecialist',
  intensiveCareSubspecialist: 'Intensive Care Subspecialist',
  openHeartAnesthesiaSubspecialist: 'Open Heart Anesthesia Subspecialist',
  plasticSurgerySubspecialist: 'Plastic Surgery Subspecialist',
  larynxSurgerySubspecialist: 'Larynx Surgery Subspecialist',
  breastCancerSurgerySubspecialist: 'Breast Cancer Surgery Subspecialist',
  gastrointestinalSurgerySubspecialist:
    'Gastrointestinal Surgery Subspecialist',
  urologicalSurgerySubspecialist: 'Urological Surgery Subspecialist',
  headAndNeckSurgerySubspecialist: 'Head and Neck Surgery Subspecialist',
  kidneyTransplantSurgerySubspecialist:
    'Kidney Transplant Surgery Subspecialist',
  thoracicSurgerySubspecialist: 'Thoracic Surgery Subspecialist',
  cardiovascularSurgerySubspecialist: 'Cardiovascular Surgery Subspecialist',
  colorectalSurgerySubspecialist: 'Colorectal Surgery Subspecialist',
  handSurgerySubspecialist: 'Hand Surgery Subspecialist',
  ophthalmicPlasticAndReconstructiveSurgerySubspecialist:
    'Ophthalmic Plastic and Reconstructive Surgery Subspecialist',
  retinaSubspecialist: 'Retina Subspecialist',
  corneaSubspecialist: 'Cornea Subspecialist',
  glaucomaSubspecialist: 'Glaucoma Subspecialist',
  allergySubspecialist: 'Allergy Subspecialist',
  pediatricSpecialist: 'Pediatric Specialist',
  pediatrician: 'Pediatrician',
  pediatricOtorhinolaryngologist: 'Pediatric Otorhinolaryngologist',
  neonatologySubspecialist: 'Neonatology Subspecialist',
  pediatricOphthalmologist: 'Pediatric Ophthalmologist',
  pediatricEndocrinologySubspecialist: 'Pediatric Endocrinology Subspecialist',
  pediatricGastroenterologySubspecialist:
    'Pediatric Gastroenterology Subspecialist',
  pediatricNeurologySubspecialist: 'Pediatric Neurology Subspecialist',
  childAndAdolescentPsychiatrist: 'Child and Adolescent Psychiatrist',
  psychologistForExceptionalChildren: 'Psychologist for Exceptional Children',
  pediatricOrthopedicsSubspecialist: 'Pediatric Orthopedics Subspecialist',
  pediatricAllergySubspecialist: 'Pediatric Allergy Subspecialist',
  pediatricSurgerySubspecialist: 'Pediatric Surgery Subspecialist',
  pediatricHematologyAndOncologySubspecialist:
    'Pediatric Hematology and Oncology Subspecialist',
  pediatricInfectiousDiseasesSubspecialist:
    'Pediatric Infectious Diseases Subspecialist',
  pediatricCardiologySubspecialist: 'Pediatric Cardiology Subspecialist',
  pediatricNephrologySubspecialist: 'Pediatric Nephrology Subspecialist',
  dentist: 'Dentist',
  dentalSurgeon: 'Dental Surgeon',
  orthodontist: 'Orthodontist',
  implantologist: 'Implantologist',
  restorativeAndCosmeticDentist: 'Restorative and Cosmetic Dentist',
  oralAndMaxillofacialSurgeon: 'Oral and Maxillofacial Surgeon',
  experiencedDentist: 'Experienced Dentist',
  pediatricDentist: 'Pediatric Dentist',
  oralMedicineSpecialist: 'Oral Medicine Specialist',
  periodontist: 'Periodontist',
  prosthodontist: 'Prosthodontist',
  endodontist: 'Endodontist',
  experiencedDenturist: 'Experienced Denturist',
  denturist: 'Denturist',
  hospitals: 'Hospitals',
  hospital: 'Hospital',
  cardiologyHospital: 'Cardiology Hospital',
  obstetricsAndGynecologyHospital: 'Obstetrics and Gynecology Hospital',
  otorhinolaryngologyHospital: 'Otorhinolaryngology Hospital',
  urologyHospital: 'Urology Hospital',
  burnHospital: 'Burn Hospital',
  psychiatricHospital: 'Psychiatric Hospital',
  orthopedicHospital: 'Orthopedic Hospital',
  ophthalmologyHospital: 'Ophthalmology Hospital',
  pulmonaryHospital: 'Pulmonary Hospital',
  cancerHospital: 'Cancer Hospital',
  pediatricHospital: 'Pediatric Hospital',
  clinicsAndMedicalCenters: 'Clinics and Medical Centers',
  medicalCenter: 'Medical Center',
  dentalClinic: 'Dental Clinic',
  hairTransplantClinic: 'Hair Transplant Clinic',
  cardiologyClinic: 'Cardiology Clinic',
  audiologyClinic: 'Audiology Clinic',
  ophthalmologyClinic: 'Ophthalmology Clinic',
  orthopedicsClinic: 'Orthopedics Clinic',
  nutritionClinic: 'Nutrition Clinic',
  dermatologyClinic: 'Dermatology Clinic',
  allergyClinic: 'Allergy Clinic',
  psychiatricClinic: 'Psychiatric Clinic',
  homeopathyClinic: 'Homeopathy Clinic',
  nuclearMedicineClinic: 'Nuclear Medicine Clinic',
  sleepDisordersClinic: 'Sleep Disorders Clinic',
  addictionTreatmentClinic: 'Addiction Treatment Clinic',
  limitedAndOutpatientSurgeryClinic: 'Limited and Outpatient Surgery Clinic',
  specializedPainClinic: 'Specialized Pain Clinic',
  acupunctureClinic: 'Acupuncture Clinic',
  speechTherapyClinic: 'Speech Therapy Clinic',
  infertilityClinic: 'Infertility Clinic',
  hepatitisClinic: 'Hepatitis Clinic',
  orthoticsAndProsthetics: 'Orthotics and Prosthetics',
  audiology: 'Audiology',
  physiotherapyClinic: 'Physiotherapy Clinic',
  psychologyClinic: 'Psychology Clinic',
  diagnosisAndTreatmentCenters: 'Diagnosis and Treatment Centers',
  medicalImagingCenter: 'Medical Imaging Center',
  radiotherapy: 'Radiotherapy',
  endoscopy: 'Endoscopy (Colonoscopy, EGD)',
  hypnotherapy: 'Hypnotherapy',
  neurotherapyCenter: 'Neurotherapy Center',
  medicalDiagnosticLaboratory: 'Medical Diagnostic Laboratory',
  healthcareCenter: 'Healthcare Center',
  virologyLaboratory: 'Virology Laboratory',
  marriageAndFamilyCounselingCenter: 'Marriage and Family Counseling Center',
  medicalBuilding: 'Medical Building',
  nerveAndMuscleElectromyography: 'Nerve and Muscle Electromyography (EMG)',
  electrocardiogram: 'Electrocardiogram (ECG)',
  electroencephalogram: 'Electroencephalogram (EEG)',
  emergencyCenter: 'Emergency Center',
  nursingHome: 'Nursing Home',
  veteransSanatorium: 'Veterans Sanatorium',
  disabledSanatorium: 'Disabled Sanatorium',
  orphanageAndInfantHome: 'Orphanage and Infant Home',
  veterinaryMedicine: 'Veterinary Medicine',
  massageTherapy: 'Massage Therapy',
  healthCenter: 'Health Center',
  healthHouse: 'Health House',
  rehabilitationCenter: 'Rehabilitation Center',
  welfareOrganization: 'Welfare Organization',
  socialWork: 'Social Work',
  laserTherapy: 'Laser Therapy',
  complementaryMedicine: 'Complementary Medicine',
  bloodTransfusionBase: 'Blood Transfusion Base',
  optometry: 'Optometry',
  physiotherapy: 'Physiotherapy',
  geneticCounseling: 'Genetic Counseling',
  occupationalTherapy: 'Occupational Therapy',
  speechTherapy: 'Speech Therapy',
  chemotherapy: 'Chemotherapy',
  yumiHoTherapy: 'Yumi Ho Therapy',
  pathobiologyLaboratory: 'Pathobiology Laboratory',
  medicalServices: 'Medical Services',
  forensicMedicine: 'Forensic Medicine',
  homeMedicalServices: 'Home Medical Services',
  ambulance: 'Ambulance',
  healthcareConsultingAndServices: 'Healthcare Consulting and Services',
  occupationalHealthAndMedicine: 'Occupational Health and Medicine',
  nutritionExpert: 'Nutrition Expert',
  medicine: 'Medicine',
  pharmacy: 'Pharmacy',
  roundTheClockPharmacy: '24-Hour Pharmacy',
  veterinaryPharmacy: 'Veterinary Pharmacy',
  pharmaceuticals: 'Pharmaceuticals',
  pharmaceuticalRawMaterialsProduction:
    'Pharmaceutical Raw Materials Production',
  medicineDistribution: 'Medicine Distribution',
  herbalMedicineDistribution: 'Herbal Medicine Distribution',
  herbalMedicineForLivestockAndPoultryDistribution:
    'Herbal Medicine for Livestock and Poultry Distribution',
  medicalEquipment: 'Medical Equipment',
  ophthalmicEquipmentSales: 'Ophthalmic Equipment Sales',
  dentalEquipmentRepair: 'Dental Equipment Repair',
  beautyAndSlimmingEquipmentSales: 'Beauty and Slimming Equipment Sales',
  dentalEquipmentSales: 'Dental Equipment Sales',
  laboratoryEquipmentSales: 'Laboratory Equipment Sales',
  medicalLaboratoryEquipment: 'Medical Laboratory Equipment',
  medicalEquipmentProductionAndDistribution:
    'Medical Equipment Production and Distribution',
  dentalEquipmentProductionAndDistribution:
    'Dental Equipment Production and Distribution',
  orthopedicEquipmentProduction: 'Orthopedic Equipment Production',
  laboratoryEquipmentProduction: 'Laboratory Equipment Production',
  medicalEquipmentRepair: 'Medical Equipment Repair',
  laboratoryEquipmentRepair: 'Laboratory Equipment Repair',
  hearingAidsAndAssistiveListeningDevices:
    'Hearing Aids and Assistive Listening Devices',
  pharmaceuticalAndHygienicContainers: 'Pharmaceutical and Hygienic Containers',
  disposableMedicalEquipment: 'Disposable Medical Equipment',
  veterinaryEquipment: 'Veterinary Equipment',
  medicalEquipmentSales: 'Medical Equipment Sales',
  opticalManufacturing: 'Optical Manufacturing',
  traditionalMedicine: 'Traditional Medicine',
  traditionalMedicineClinic: 'Traditional Medicine Clinic',
  traditionalMedicineSpecialist: 'Traditional Medicine Specialist',
  acupuncturist: 'Acupuncturist',
  clothingAndJewelry: 'Clothing and Jewelry',
  clothingAndJewelrySales: 'Clothing and Jewelry Sales',
  boutique: 'Boutique',
  stroller: 'Stroller',
  womensClothingSales: "Women's Clothing Sales",
  mensClothingSales: "Men's Clothing Sales",
  childrensClothingSales: "Children's Clothing Sales",
  babySetSales: 'Baby Set Sales',
  sportswearAndEquipmentSales: 'Sportswear and Equipment Sales',
  shoeSales: 'Shoe Sales',
  bagAndLuggageSales: 'Bag and Luggage Sales',
  militaryClothingSales: 'Military Clothing Sales',
  workAndSafetyClothingSales: 'Work and Safety Clothing Sales',
  sewingSuppliesSales: 'Sewing Supplies Sales',
  underwearSales: 'Underwear Sales',
  leatherProductsSales: 'Leather Products Sales',
  sportsShoes: 'Sports Shoes',
  weddingDress: 'Wedding Dress',
  textiles: 'Textiles',
  syntheticLeather: 'Synthetic Leather',
  secondHandClothing: 'Second-hand Clothing',
  tentAndTarpaulin: 'Tent and Tarpaulin',
  mourningReligiousGroupEmblem: 'Mourning Religious Group Emblem',
  goldAndJewelrySales: 'Gold and Jewelry Sales',
  watchSales: 'Watch Sales',
  promotionalWatch: 'Promotional Watch',
  clothingAndJewelryServices: 'Clothing and Jewelry Services',
  tailoring: 'Tailoring',
  textileChemicalsSales: 'Textile Chemicals Sales',
  fashionDesign: 'Fashion Design',
  clothingServices: 'Clothing Services',
  shoeRepair: 'Shoe Repair',
  shoemakingSupplies: 'Shoemaking Supplies',
  fabricDistribution: 'Fabric Distribution',
  fabricServices: 'Fabric Services',
  textileIndustry: 'Textile Industry',
  textileServices: 'Textile Services',
  textileRawMaterials: 'Textile Raw Materials',
  textileDyeSales: 'Textile Dye Sales',
  saddlery: 'Saddlery',
  weaving: 'Weaving',
  watchRepair: 'Watch Repair',
  embroidery: 'Embroidery',
  dryCleaning: 'Dry Cleaning',
  clothingAndJewelryProduction: 'Clothing and Jewelry Production',
  womensChadorSewingAndSales: "Women's Chador Sewing and Sales",
  watchmaking: 'Watchmaking',
  womensClothingProductionAndDistribution:
    "Women's Clothing Production and Distribution",
  mensClothingProductionAndDistribution:
    "Men's Clothing Production and Distribution",
  childrensClothingProductionAndDistribution:
    "Children's Clothing Production and Distribution",
  babySetProductionAndDistribution: 'Baby Set Production and Distribution',
  sportswearAndEquipmentProductionAndDistribution:
    'Sportswear and Equipment Production and Distribution',
  clothingProductionAndDistribution: 'Clothing Production and Distribution',
  socksProductionAndDistribution: 'Socks Production and Distribution',
  watchProduction: 'Watch Production',
  workAndSafetyClothingProduction: 'Work and Safety Clothing Production',
  militaryClothingProduction: 'Military Clothing Production',
  underwearProductionAndDistribution: 'Underwear Production and Distribution',
  fabricProduction: 'Fabric Production',
  shoeProduction: 'Shoe Production',
  bagAndShoeProduction: 'Bag and Shoe Production',
  bagAndLuggageProduction: 'Bag and Luggage Production',
  leatherAndSalamoorProductionAndSales:
    'Leather and Salamoor Production and Sales',
  medicalClothing: 'Medical Clothing',
  shoeDistribution: 'Shoe Distribution',
  homeBuildingAndInstallations: 'Home, Building and Installations',
  householdAndOfficeAppliancesSales: 'Household and Office Appliances - Sales',
  householdAppliancesSales: 'Household Appliances Sales',
  mattressAndBed: 'Mattress and Bed',
  mattressQuiltAndPillowSales: 'Mattress, Quilt and Pillow Sales',
  potAndPanSales: 'Pot and Pan Sales',
  furnitureAndDecorSales: 'Furniture and Decor Sales',
  kitchenSuppliesAndUtensilsSales: 'Kitchen Supplies and Utensils Sales',
  audioAndVideoEquipmentSales: 'Audio and Video Equipment Sales',
  carpetAndRugSales: 'Carpet and Rug Sales',
  curtainSaleAndInstallation: 'Curtain Sale and Installation',
  officeFurnitureSales: 'Office Furniture Sales',
  householdAppliancesSparePartsSales: 'Household Appliances Spare Parts Sales',
  prefabricatedOfficeEquipment: 'Prefabricated Office Equipment',
  waterPurifierSalesAndRepair: 'Water Purifier Sales and Repair',
  householdAndOfficeAppliancesProduction:
    'Household and Office Appliances - Production',
  householdAppliancesProduction: 'Household Appliances Production',
  potAndPanProduction: 'Pot and Pan Production',
  furnitureAndDecorProductionAndDistribution:
    'Furniture and Decor Production and Distribution',
  kitchenwareProduction: 'Kitchenware Production',
  officeEquipmentProductionAndSales: 'Office Equipment Production and Sales',
  carpetAndRugProduction: 'Carpet and Rug Production',
  crystalAndCrystalWareProduction: 'Crystal and Crystal Ware Production',
  mirrorAndCandlestickProductionAndDistribution:
    'Mirror and Candlestick Production and Distribution',
  gasStoveProduction: 'Gas Stove Production',
  digitalScaleProduction: 'Digital Scale Production',
  sewingMachineProduction: 'Sewing Machine Production',
  washingMachineProduction: 'Washing Machine Production',
  vacuumCleanerProduction: 'Vacuum Cleaner Production',
  meatGrinderProduction: 'Meat Grinder Production',
  householdRefrigeratorAndFreezerProduction:
    'Household Refrigerator and Freezer Production',
  gasPoweredHouseholdAppliancesProduction:
    'Gas-powered Household Appliances Production',
  chandelierAndLampProductionAndDistribution:
    'Chandelier and Lamp Production and Distribution',
  televisionProduction: 'Television Production',
  audioAndVideoEquipmentProduction: 'Audio and Video Equipment Production',
  samovarMaking: 'Samovar Making',
  freestandingAndBuiltInGasStoveProduction:
    'Freestanding and Built-in Gas Stove Production',
  constructionAndDevelopment: 'Construction and Development',
  realEstateConsultant: 'Real Estate Consultant',
  greenhouseStructure: 'Greenhouse Structure',
  falseFloorProductionAndImplementation:
    'False Floor Production and Implementation',
  steelDeckCeilingSales: 'Steel Deck Ceiling Sales',
  villaConstruction: 'Villa Construction',
  acousticDoor: 'Acoustic Door',
  lightWeightBlock: 'Lightweight Block',
  foamConcrete: 'Foam Concrete',
  pvcCeilingTileProductionAndImplementation:
    'PVC Ceiling Tile Production and Implementation',
  buildingDesignAndArchitecture: 'Building Design and Architecture',
  buildingMaterials: 'Building Materials',
  permitIssuance: 'Permit Issuance',
  interiorArchitecture: 'Interior Architecture',
  constructionCompany: 'Construction Company',
  buildingAutomation: 'Building Automation',
  smartBuilding: 'Smart Building',
  buildingRenovationAndRestoration: 'Building Renovation and Restoration',
  concrete: 'Concrete',
  scaffolding: 'Scaffolding',
  buildingPainting: 'Building Painting',
  portableCabinContainerAndCaravan: 'Portable Cabin, Container and Caravan',
  excavation: 'Excavation',
  landscaping: 'Landscaping',
  townshipDevelopment: 'Township Development',
  constructionChemicals: 'Construction Chemicals',
  acousticFalseCeiling: 'Acoustic False Ceiling',
  windowDisplayDecoration: 'Window Display Decoration',
  thermalAndRefrigerationInsulation: 'Thermal and Refrigeration Insulation',
  moistureInsulation: 'Moisture Insulation',
  lightWeightStructuralSystem: 'Lightweight Structural System',
  structuralStrengthening: 'Structural Strengthening',
  constructionAndIndustrialPaintSales:
    'Construction and Industrial Paint Sales',
  studProduction: 'Stud Production',
  studSales: 'Stud Sales',
  carpentry: 'Carpentry',
  exhibitionHallDesignAndImplementation:
    'Exhibition Hall Design and Implementation',
  framing: 'Framing',
  grinding: 'Grinding',
  spaceFrameDesignAndProduction: 'Space Frame Design and Production',
  louveredWall: 'Louvered Wall',
  prefabricatedBuildingComponents: 'Prefabricated Building Components',
  parkingSafetyEquipmentAndSupplies: 'Parking Safety Equipment and Supplies',
  roofGardenDesignAndImplementation: 'Roof Garden Design and Implementation',
  buildingFacilities: 'Building Facilities',
  cctvEquipmentProduction: 'CCTV Equipment Production',
  burglarAlarmAndAntiTheftSystemProduction:
    'Burglar Alarm and Anti-theft System Production',
  identificationAndSecurityEquipmentSales:
    'Identification and Security Equipment Sales',
  cctvEquipmentSaleAndInstallation: 'CCTV Equipment Sale and Installation',
  firefightingEquipmentProduction: 'Firefighting Equipment Production',
  fireExtinguisher: 'Fire Extinguisher',
  firefightingEquipmentSales: 'Firefighting Equipment Sales',
  fireAlarmAndSuppressionSystemSales: 'Fire Alarm and Suppression System Sales',
  burglarAlarmAndAntiTheftSystemSales:
    'Burglar Alarm and Anti-theft System Sales',
  electronicSecurityAndProtectionSystemProduction:
    'Electronic Security and Protection System Production',
  electronicSecurityAndProtectionSystemSales:
    'Electronic Security and Protection System Sales',
  hoseProduction: 'Hose Production',
  electricalPanelEquipmentProduction: 'Electrical Panel Equipment Production',
  securityAndProtectionSystem: 'Security and Protection System',
  coolingSystems: 'Cooling Systems',
  facilitiesAndEquipmentContractor: 'Facilities and Equipment Contractor',
  buildingFacilitiesEquipment: 'Building Facilities Equipment',
  coldStorage: 'Cold Storage',
  mechanicalBuildingFacilities: 'Mechanical Building Facilities',
  wireAndCable: 'Wire and Cable',
  heatingSystems: 'Heating Systems',
  lightingEquipment: 'Lighting Equipment',
  pipesAndFittings: 'Pipes and Fittings',
  electricalAndSecurityBuildingFacilities:
    'Electrical and Security Building Facilities',
  multistageCentrifugalPump: 'Multistage Centrifugal Pump',
  industrialFacilities: 'Industrial Facilities',
  videoIntercom: 'Video Intercom',
  meter: 'Meter',
  antenna: 'Antenna',
  industrialOrBuildingElectricalWiring:
    'Industrial or Building Electrical Wiring',
  electricalFacilities: 'Electrical Facilities',
  elevatorSales: 'Elevator Sales',
  escalatorProduction: 'Escalator Production',
  escalatorEquipment: 'Escalator Equipment',
  escalatorSaleInstallationAndRepair: 'Escalator Sale, Installation and Repair',
  urbanFacilities: 'Urban Facilities',
  garbageChute: 'Garbage Chute',
  poolSaunaAndJacuzziEquipment: 'Pool, Sauna and Jacuzzi Equipment',
  patioFountainAndWaterfall: 'Patio Fountain and Waterfall',
  industrialInsulation: 'Industrial Insulation',
  waterAndWastewaterTreatment: 'Water and Wastewater Treatment',
  buildingEquipmentAndDecor: 'Building Equipment and Decor',
  buildingDecor: 'Building Decor',
  hotelEquipment: 'Hotel Equipment',
  vanityCabinetProductionAndSales: 'Vanity Cabinet Production and Sales',
  doorsAndWindows: 'Doors and Windows',
  tileAndCeramic: 'Tile and Ceramic',
  faucetsAndFittings: 'Faucets and Fittings',
  flooringAndParquet: 'Flooring and Parquet',
  buildingSanitarySupplies: 'Building Sanitary Supplies',
  wallpaper: 'Wallpaper',
  glassAndMirror: 'Glass and Mirror',
  buildingAndDecorativeStone: 'Building and Decorative Stone',
  roofAndBuildingFacade: 'Roof and Building Facade',
  carpetSaleAndInstallation: 'Carpet Sale and Installation',
  fireplace: 'Fireplace',
  partition: 'Partition',
  iraniteAndShirvani: 'Iranite and Shirvani',
  boxAndShelf: 'Box and Shelf',
  lockAndHandle: 'Lock and Handle',
  cabinetProductionAndSales: 'Cabinet Production and Sales',
  cinemaHallEquipment: 'Cinema Hall Equipment',
  tentAndCanopy: 'Tent and Canopy',
  shelving: 'Shelving',
  lath: 'Lath',
  decorativeSticker: 'Decorative Sticker',
  plasterStuccoWork: 'Plaster Stucco Work',
  wallCovering: 'Wall Covering',
  carpetProduction: 'Carpet Production',
  roofTileSales: 'Roof Tile Sales',
  homeAndBuildingServices: 'Home and Building Services',
  carpetCleaning: 'Carpet Cleaning',
  constructionServices: 'Construction Services',
  glassDoorRepair: 'Glass Door Repair',
  dishwasherRepair: 'Dishwasher Repair',
  automaticDoorRepair: 'Automatic Door Repair',
  sofaDryCleaning: 'Sofa Dry Cleaning',
  afterSalesServiceAndRepairOfHouseholdAppliances:
    'After-Sales Service and Repair of Household Appliances',
  homeAndOfficeFurnitureRepair: 'Home and Office Furniture Repair',
  officeFurnitureAndChairRepair: 'Office Furniture and Chair Repair',
  plumbing: 'Plumbing',
  carpetAndRugServices: 'Carpet and Rug Services',
  utilitiesServices: 'Utilities Services',
  drainCleaningAndWellEmptying: 'Drain Cleaning and Well Emptying',
  publicAndGovernmentalServices: 'Public and Governmental Services',
  publicServices: 'Public Services',
  police10: 'Police 10',
  lawOffice: 'Law Office',
  communicationServicesOffice: 'Communication Services Office',
  cityElectronicServicesOffice: 'City Electronic Services Office',
  notaryOffice: 'Notary Office',
  governmentCitizenServiceOffice: 'Government Citizen Service Office',
  companyRegistration: 'Company Registration',
  lawyer: 'Lawyer',
  translationOffice: 'Translation Office',
  disputeResolutionCouncil: 'Dispute Resolution Council',
  civilRegistrationOffice: 'Civil Registration Office',
  marriageAndDivorceRegistrationOffice:
    'Marriage and Divorce Registration Office',
  airlineAgencyLicenseRegistration: 'Airline Agency License Registration',
  deedsAndRealEstateRegistrationOffice:
    'Deeds and Real Estate Registration Office',
  database: 'Database',
  gasEmergency: 'Gas Emergency',
  privateDetectiveAgency: 'Private Detective Agency',
  publicWarehouse: 'Public Warehouse',
  serviceCompany: 'Service Company',
  sourceOfEmulationOffice: 'Source of Emulation Office',
  fireEmergency: 'Fire Emergency',
  waterEmergency: 'Water Emergency',
  cityLandmarks: 'City Landmarks',
  stampSales: 'Stamp Sales',
  metalShelfEquipment: 'Metal Shelf Equipment',
  flowerShop: 'Flower Shop',
  birdShop: 'Bird Shop',
  keyMaking: 'Key Making',
  publicBathhouse: 'Public Bathhouse',
  charitableFoundation: 'Charitable Foundation',
  conscriptionOrganization: 'Conscription Organization',
  policeStationAndOutpost: 'Police Station and Outpost',
  criminalInvestigationPolice: 'Criminal Investigation Police',
  prosecutorOfficeAndPublicCourt: 'Prosecutor Office and Public Court',
  courtAndJudicialComplex: 'Court and Judicial Complex',
  prison: 'Prison',
  lawEnforcementCenter: 'Law Enforcement Center',
  policeDepartmentsAndAgencies: 'Police Departments and Agencies (NAJA)',
  airportPolice: 'Airport Police',
  railwayPolice: 'Railway Police',
  forestAndRangelandProtectionUnit: 'Forest and Rangeland Protection Unit',
  prisonProtectionUnit: 'Prison Protection Unit',
  culturalHeritageProtectionUnit: 'Cultural Heritage Protection Unit',
  environmentalProtectionUnit: 'Environmental Protection Unit',
  governmentOffices: 'Government Offices',
  organizationsAndGovernmentOffices: 'Organizations and Government Offices',
  medicalCouncilOrganization: 'Medical Council Organization',
  consulate: 'Consulate',
  retirees: 'Retirees',
  unionAssociationCooperative: 'Union, Association, Cooperative',
  trafficDepartment: 'Traffic Department',
  educationDistricts: 'Education Districts',
  internationalOrganization: 'International Organization',
  municipalDepartmentsAndOrganizations:
    'Municipal Departments and Organizations',
  municipalDistrictsAndAreas: 'Municipal Districts and Areas',
  institutionsOrganizationsAndBodiesAffiliatedWithTheLeadership:
    'Institutions, Organizations and Bodies Affiliated with the Leadership',
  institutionsOrganizationsAndBodiesAffiliatedWithTheLegislature:
    'Institutions, Organizations and Bodies Affiliated with the Legislature',
  institutionsOrganizationsAndBodiesAffiliatedWithThePresidency:
    'Institutions, Organizations and Bodies Affiliated with the Presidency',
  institutionsOrganizationsAndBodiesAffiliatedWithTheJudiciary:
    'Institutions, Organizations and Bodies Affiliated with the Judiciary',
  judicialElectronicServicesOffice: 'Judicial Electronic Services Office',
  leadership: 'Leadership',
  nonGovernmentalOrganization: 'Non-Governmental Organization (NGO)',
  embassy: 'Embassy',
  postalDistricts: 'Postal Districts',
  electricityDistricts: 'Electricity Districts',
  telecommunicationDistrict: 'Telecommunication District',
  reliefCommittee: 'Relief Committee',
  broadcastingNetwork: 'Broadcasting Network (Seda)',
  countyRadioAndTelevision: 'County Radio and Television',
  radioAndTelevisionDepartmentsAndOrganizations:
    'Radio and Television Departments and Organizations',
  radioAndTelevisionTelevisionNetwork:
    'Radio and Television Television Network',
  presidency: 'Presidency',
  basijCenter: 'Basij Center',
  militaryBarracks: 'Military Barracks',
  sportsFederation: 'Sports Federation',
  ministries: 'Ministries',
  ministryOfEducation: 'Ministry of Education',
  ministryOfHealthTreatmentAndMedicalEducation:
    'Ministry of Health, Treatment and Medical Education',
  ministryOfForeignAffairs: 'Ministry of Foreign Affairs',
  ministryOfRoadAndUrbanDevelopment: 'Ministry of Road and Urban Development',
  ministryOfScienceResearchAndTechnology:
    'Ministry of Science, Research and Technology',
  ministryOfAgriculturalJihad: 'Ministry of Agricultural Jihad',
  ministryOfInformationAndCommunicationsTechnology:
    'Ministry of Information and Communications Technology',
  ministryOfIntelligence: 'Ministry of Intelligence',
  ministryOfEconomicAffairsAndFinance:
    'Ministry of Economic Affairs and Finance',
  ministryOfJustice: 'Ministry of Justice',
  ministryOfDefenseAndArmedForcesSupport:
    'Ministry of Defense and Armed Forces Support',
  ministryOfIndustryMineAndTrade: 'Ministry of Industry, Mine and Trade',
  ministryOfCultureAndIslamicGuidance:
    'Ministry of Culture and Islamic Guidance',
  ministryOfInterior: 'Ministry of Interior',
  ministryOfOil: 'Ministry of Oil',
  ministryOfEnergy: 'Ministry of Energy',
  ministryOfSportsAndYouth: 'Ministry of Sports and Youth',
  ministryOfCooperativesLabourAndSocialWelfare:
    'Ministry of Cooperatives, Labour and Social Welfare',
  ministryOfCulturalHeritageTourismAndHandicrafts:
    'Ministry of Cultural Heritage, Tourism and Handicrafts',
  protocolAndCeremonies: 'Protocol and Ceremonies',
  ceremonyAndEventServices: 'Ceremony and Event Services',
  aerialImagingHelicopterShot: 'Aerial Imaging (Helicopter Shot)',
  seminarOrganizationServices: 'Seminar Organization Services',
  receptionHall: 'Reception Hall',
  photographyAndFilming: 'Photography and Filming',
  photoStudio: 'Photo Studio',
  weddingInvitationCard: 'Wedding Invitation Card',
  birthdayDecoration: 'Birthday Decoration',
  securityAndSurveillanceInstitute: 'Security and Surveillance Institute',
  financialAndBankingServices: 'Financial and Banking Services',
  mobileCardReaderDevice: 'Mobile Card Reader Device',
  coinTrading: 'Coin Trading',
  bank: 'Bank',
  atm: 'ATM',
  qardAlHasanahBank: 'Qard al-Hasanah Bank',
  foreignBank: 'Foreign Bank',
  financialAndCreditInstitution: 'Financial and Credit Institution',
  currencyExchange: 'Currency Exchange',
  qardAlHasanahFund: 'Qard al-Hasanah Fund',
  shoppingCenters: 'Shopping Centers',
  passageAndCommercialComplex: 'Passage and Commercial Complex',
  chainStore: 'Chain Store',
  consumerCooperativeStore: 'Consumer Cooperative Store',
  fruitAndVegetableMarket: 'Fruit and Vegetable Market',
  occupationalRow: 'Occupational Row',
  tobaccoProducts: 'Tobacco Products',
  tobaccoProduction: 'Tobacco Production',
  hookahSales: 'Hookah Sales',
  cigaretteSales: 'Cigarette Sales',
  matchProductionAndDistribution: 'Match Production and Distribution',
  charcoalSales: 'Charcoal Sales',
  restaurantAndFood: 'Restaurant and Food',
  restaurantAndSnackBar: 'Restaurant and Snack Bar',
  restaurant: 'Restaurant',
  pizzaAndSandwich: 'Pizza and Sandwich',
  fastFood: 'Fast Food',
  chelowKabab: 'Chelow Kabab',
  kebabAndLiverShop: 'Kebab and Liver Shop',
  foreignCuisineRestaurant: 'Foreign Cuisine Restaurant',
  vegetarianRestaurant: 'Vegetarian Restaurant',
  traditionalDiningHall: 'Traditional Dining Hall',
  coffeeShop: 'Coffee Shop',
  mealPreparation: 'Meal Preparation',
  cooking: 'Cooking',
  halimAndAshPreparation: 'Halim and Ash Preparation',
  traditionalCoffeeHouse: 'Traditional Coffee House',
  coffeeHouseAndDiziSara: 'Coffee House and Dizi Sara',
  foodSales: 'Food Sales',
  foodRawMaterialsSales: 'Food Raw Materials Sales',
  sausageAndColdCutsAndProteinMeatProductsSales:
    'Sausage, Cold Cuts and Protein Meat Products Sales',
  teaAndHerbalInfusionSales: 'Tea and Herbal Infusion Sales',
  teaSales: 'Tea Sales',
  fruitLeatherSales: 'Fruit Leather Sales',
  cheeseSales: 'Cheese Sales',
  kashkSales: 'Kashk Sales',
  sohanAndGazSales: 'Sohan and Gaz Sales',
  biscuitSales: 'Biscuit Sales',
  cakeAndCookieSales: 'Cake and Cookie Sales',
  dateSales: 'Date Sales',
  honeySales: 'Honey Sales',
  saffronSales: 'Saffron Sales',
  riceSales: 'Rice Sales',
  legumeSales: 'Legume Sales',
  cocoaPowderSales: 'Cocoa Powder Sales',
  confectioneryAndPastryRawMaterialsSales:
    'Confectionery and Pastry Raw Materials Sales',
  driedFruitAndFruitChipsSales: 'Dried Fruit and Fruit Chips Sales',
  starchSales: 'Starch Sales',
  yeastSales: 'Yeast Sales',
  oilseedSales: 'Oilseed Sales',
  butterSales: 'Butter Sales',
  oliveOilSales: 'Olive Oil Sales',
  frozenFoodSales: 'Frozen Food Sales',
  spiceSales: 'Spice Sales',
  picklesSales: 'Pickles Sales',
  raisin: 'Raisin',
  seeds: 'Seeds',
  groceryStore: 'Grocery Store',
  meatAndMeatProductsSales: 'Meat and Meat Products Sales',
  snacks: 'Snacks',
  wholesaleFoodSales: 'Wholesale Food Sales',
  fruitAndVegetableSales: 'Fruit and Vegetable Sales',
  juiceAndIceCreamSales: 'Juice and Ice Cream Sales',
  nutAndDriedFruitSales: 'Nut and Dried Fruit Sales',
  pistachioSales: 'Pistachio Sales',
  supermarket: 'Supermarket',
  bakery: 'Bakery',
  butchery: 'Butchery',
  poultryShop: 'Poultry Shop',
  fishAndShrimpSales: 'Fish and Shrimp Sales',
  confectionery: 'Confectionery',
  rockCandySales: 'Rock Candy Sales',
  foodServices: 'Food Services',
  iceCreamDistribution: 'Ice Cream Distribution',
  dairyDistribution: 'Dairy Distribution',
  foodRawMaterialsDistribution: 'Food Raw Materials Distribution',
  softDrinkDistribution: 'Soft Drink Distribution',
  eggDistribution: 'Egg Distribution',
  mineralWaterDistribution: 'Mineral Water Distribution',
  vegetableOilDistribution: 'Vegetable Oil Distribution',
  tomatoPasteDistribution: 'Tomato Paste Distribution',
  beverageServices: 'Beverage Services',
  foodDistribution: 'Food Distribution',
  proteinMaterialsDistribution: 'Protein Materials Distribution',
  foodPackaging: 'Food Packaging',
  driedFruitPackaging: 'Dried Fruit Packaging',
  legumesPackaging: 'Legumes Packaging',
  scaleAndBalanceRepair: 'Scale and Balance Repair',
  sausageSlicerRepair: 'Sausage Slicer Repair',
  fastFoodRawMaterialsDistribution: 'Fast Food Raw Materials Distribution',
  teaDistribution: 'Tea Distribution',
  foodProduction: 'Food Production',
  teaAndHerbalInfusionProduction: 'Tea and Herbal Infusion Production',
  coffeeAndNescafeProduction: 'Coffee and Nescafe Production',
  honeyProduction: 'Honey Production',
  caviarProduction: 'Caviar Production',
  cottonCandyProduction: 'Cotton Candy Production',
  organicFoodMaterialAndProductProduction:
    'Organic Food Material and Product Production',
  oilseedProduction: 'Oilseed Production',
  mushroomProduction: 'Mushroom Production',
  saltProduction: 'Salt Production',
  oliveOilProduction: 'Olive Oil Production',
  vegetableOilProduction: 'Vegetable Oil Production',
  cannedFoodProduction: 'Canned Food Production',
  chipsProduction: 'Chips Production',
  jamProduction: 'Jam Production',
  fruitJuiceProduction: 'Fruit Juice Production',
  milkProduction: 'Milk Production',
  butterProduction: 'Butter Production',
  dairyProduction: 'Dairy Production',
  flourProduction: 'Flour Production',
  starchProduction: 'Starch Production',
  sugarAndLumpSugarProduction: 'Sugar and Lump Sugar Production',
  gumProduction: 'Gum Production',
  halvaProduction: 'Halva Production',
  sohanMaking: 'Sohan Making',
  chocolateAndCandyProduction: 'Chocolate and Candy Production',
  pastaProduction: 'Pasta Production',
  teaProduction: 'Tea Production',
  yeastProduction: 'Yeast Production',
  babyFoodProduction: 'Baby Food Production',
  tomatoPasteProduction: 'Tomato Paste Production',
  samanuMaking: 'Samanu Making',
  iceProduction: 'Ice Production',
  softDrinkProduction: 'Soft Drink Production',
  mineralWaterProduction: 'Mineral Water Production',
  rosewaterProduction: 'Rosewater Production',
  cerealProduction: 'Cereal Production',
  wheatProduction: 'Wheat Production',
  soybeanProduction: 'Soybean Production',
  eggProduction: 'Egg Production',
  vegetableChoppingAndLemonJuiceAndVerjuiceExtraction:
    'Vegetable Chopping and Lemon/Verjuice Extraction',
  spiceProduction: 'Spice Production',
  picklesProduction: 'Pickles Production',
  condimentProduction: 'Condiment Production',
  foodIndustry: 'Food Industry',
  restaurantConsultingAndSetup: 'Restaurant Consulting and Setup',
  foodRawMaterialsImportExport: 'Food Raw Materials Import/Export',
  softDrinkCupProduction: 'Soft Drink Cup Production',
  confectioneryAndPastryEquipmentProduction:
    'Confectionery and Pastry Equipment Production',
  industrialKitchenEquipmentSales: 'Industrial Kitchen Equipment Sales',
  sausageSlicerSales: 'Sausage Slicer Sales',
  coffeeShopSuppliesAndEquipmentProduction:
    'Coffee Shop Supplies and Equipment Production',
  coffeeShopSetup: 'Coffee Shop Setup',
  foodIndustryConsultant: 'Food Industry Consultant',
  foodQualityControl: 'Food Quality Control',
  coffeeShopSuppliesAndEquipmentSales:
    'Coffee Shop Supplies and Equipment Sales',
  digitalScaleSales: 'Digital Scale Sales',
  scaleOperation: 'Scale Operation',
  industrialMixerProduction: 'Industrial Mixer Production',
  industrialKitchenEquipmentProduction:
    'Industrial Kitchen Equipment Production',
  digitalScaleRepair: 'Digital Scale Repair',
  scaleAndBalanceProduction: 'Scale and Balance Production',
  iceCreamMaker: 'Ice Cream Maker',
  handTrolleyProduction: 'Hand Trolley Production',
  confectioneryAndPastrySuppliesSales:
    'Confectionery and Pastry Supplies Sales',
  industry: 'Industry',
  designAndProductionIndustries: 'Design and Production Industries',
  aerospaceIndustry: 'Aerospace Industry',
  laserEngraving: 'Laser Engraving',
  industrialSalt: 'Industrial Salt',
  stuffingProduction: 'Stuffing Production',
  drillingEquipmentAndSuppliesProduction:
    'Drilling Equipment and Supplies Production',
  plasticNetProduction: 'Plastic Net Production',
  nylonAndNylonxProduction: 'Nylon and Nylonx Production',
  stationeryProduction: 'Stationery Production',
  crystalMaking: 'Crystal Making',
  industrialFilterProduction: 'Industrial Filter Production',
  industrialMoldMaking: 'Industrial Mold Making',
  rubberProductsProduction: 'Rubber Products Production',
  plasticProductsProduction: 'Plastic Products Production',
  industrialFurnaceProduction: 'Industrial Furnace Production',
  woodAndMetalIndustries: 'Wood and Metal Industries',
  paintCuringOvenProduction: 'Paint Curing Oven Production',
  hotAirOvenProduction: 'Hot Air Oven Production',
  woodIndustryProductionAndSales: 'Wood Industry Production and Sales',
  industrialRefrigeratorAndFreezerProduction:
    'Industrial Refrigerator and Freezer Production',
  industrialThermocoupleSales: 'Industrial Thermocouple Sales',
  medicalSportsEquipmentProduction: 'Medical Sports Equipment Production',
  industrialDesign: 'Industrial Design',
  industrialAutomation: 'Industrial Automation',
  furnitureAndOfficeChairProduction: 'Furniture and Office Chair Production',
  industrialModelMaking: 'Industrial Model Making',
  industrialPartsDesignAndProduction: 'Industrial Parts Design and Production',
  plasticMoldMaking: 'Plastic Mold Making',
  injectionPlasticMaking: 'Injection Plastic Making',
  carTireProduction: 'Car Tire Production',
  asphaltProduction: 'Asphalt Production',
  spongeAndFoamProduction: 'Sponge and Foam Production',
  spongeAndCloudProduction: 'Sponge and Cloud Production',
  wasteRecycling: 'Waste Recycling',
  mineContractor: 'Mine Contractor',
  drillingAndExtraction: 'Drilling and Extraction',
  tankProduction: 'Tank Production',
  industrialRadiography: 'Industrial Radiography',
  industrialChainProduction: 'Industrial Chain Production',
  industrialBrush: 'Industrial Brush',
  mineralMaterialsProduction: 'Mineral Materials Production',
  tankerManufacturing: 'Tanker Manufacturing',
  ovenPainting: 'Oven Painting',
  factoryEquipmentProductionAndInstallation:
    'Factory Equipment Production and Installation',
  bearingAndOilSealProduction: 'Bearing and Oil Seal Production',
  dryIce: 'Dry Ice',
  fileFolderProduction: 'File Folder Production',
  heatingElementAndThermalSuppliesProduction:
    'Heating Element and Thermal Supplies Production',
  chemicalRawMaterialsProduction: 'Chemical Raw Materials Production',
  industrialCharcoalProduction: 'Industrial Charcoal Production',
  coalProduction: 'Coal Production',
  miningEquipmentProduction: 'Mining Equipment Production',
  plasticRawMaterialsProduction: 'Plastic Raw Materials Production',
  industrialAdhesiveAndResinProduction:
    'Industrial Adhesive and Resin Production',
  castingRawMaterialsProduction: 'Casting Raw Materials Production',
  polypropyleneSackProduction: 'Polypropylene Sack Production',
  rulerProduction: 'Ruler Production',
  penProduction: 'Pen Production',
  inventor: 'Inventor',
  oilAndGasTankProduction: 'Oil and Gas Tank Production',
  siloConstruction: 'Silo Construction',
  paintAndResinProduction: 'Paint and Resin Production',
  textileChemicalsProduction: 'Textile Chemicals Production',
  industrialAdhesiveProduction: 'Industrial Adhesive Production',
  paintAndChemicalsProduction: 'Paint and Chemicals Production',
  powderPaintProduction: 'Powder Paint Production',
  distilledWaterProduction: 'Distilled Water Production',
  mineralAndIndustrialPowderProduction:
    'Mineral and Industrial Powder Production',
  adhesiveProduction: 'Adhesive Production',
  refractoryMaterialsAndPartsProduction:
    'Refractory Materials and Parts Production',
  nanotechnology: 'Nanotechnology',
  plasticBottleCapProduction: 'Plastic Bottle Cap Production',
  nylonAndNylexProduction: 'Nylon and Nylex Production',
  plasticProduction: 'Plastic Production',
  plasticMatProduction: 'Plastic Mat Production',
  industrialPlasticProduction: 'Industrial Plastic Production',
  plasticBottleProduction: 'Plastic Bottle Production',
  fabricWaste: 'Fabric Waste',
  metalWaste: 'Metal Waste',
  aluminumWaste: 'Aluminum Waste',
  scrapDealer: 'Scrap Dealer',
  textileWaste: 'Textile Waste',
  ironWaste: 'Iron Waste',
  plasticWaste: 'Plastic Waste',
  paperWaste: 'Paper Waste',
  drilling: 'Drilling',
  rubberStripProduction: 'Rubber Strip Production',
  pvcTape: 'PVC Tape',
  industrialFiber: 'Industrial Fiber',
  salesAndRepairIndustries: 'Sales and Repair Industries',
  industrialOil: 'Industrial Oil',
  ironOre: 'Iron Ore',
  tankSales: 'Tank Sales',
  pharmaceuticalRawMaterialsSales: 'Pharmaceutical Raw Materials Sales',
  scaleAndBalanceSales: 'Scale and Balance Sales',
  tankRepair: 'Tank Repair',
  marineAndShipPartsAndSuppliesSales:
    'Marine and Ship Parts and Supplies Sales',
  paintAndResinSales: 'Paint and Resin Sales',
  displayRefrigeratorSales: 'Display Refrigerator Sales',
  industrialBearingAndBallBearingSales:
    'Industrial Bearing and Ball Bearing Sales',
  tankerSales: 'Tanker Sales',
  industrialAdhesiveSales: 'Industrial Adhesive Sales',
  fiberglassRawMaterialsSales: 'Fiberglass Raw Materials Sales',
  powderPaintSales: 'Powder Paint Sales',
  mineralAndIndustrialPowderSales: 'Mineral and Industrial Powder Sales',
  refractoryMaterialsAndPartsSales: 'Refractory Materials and Parts Sales',
  plasticBottleSales: 'Plastic Bottle Sales',
  drillingEquipmentAndSuppliesSales: 'Drilling Equipment and Supplies Sales',
  industrialBrushSales: 'Industrial Brush Sales',
  drillingMachinerySales: 'Drilling Machinery Sales',
  cncCutting: 'CNC Cutting',
  waxAndPolishSales: 'Wax and Polish Sales',
  plasticAndPolypropyleneBagSales: 'Plastic and Polypropylene Bag Sales',
  bubblePlasticSales: 'Bubble Plastic Sales',
  mineralPumiceSales: 'Mineral Pumice Sales',
  laboratoryMaterialsSales: 'Laboratory Materials Sales',
  chemicalSubstances: 'Chemical Substances',
  industrialFilterSales: 'Industrial Filter Sales',
  chemicalRawMaterialsSales: 'Chemical Raw Materials Sales',
  plasticProductsSales: 'Plastic Products Sales',
  coldStorageRental: 'Cold Storage Rental',
  inductionFurnaceProduction: 'Induction Furnace Production',
  industrialRefrigeratorAndFreezerRepair:
    'Industrial Refrigerator and Freezer Repair',
  industrialRefrigeratorAndFreezerSales:
    'Industrial Refrigerator and Freezer Sales',
  industrialChainSales: 'Industrial Chain Sales',
  adhesiveSales: 'Adhesive Sales',
  industrialCharcoalSales: 'Industrial Charcoal Sales',
  coalSales: 'Coal Sales',
  rubberCutting: 'Rubber Cutting',
  miningEquipmentSales: 'Mining Equipment Sales',
  bearingAndOilSealSales: 'Bearing and Oil Seal Sales',
  chemicalSubstancesSales: 'Chemical Substances Sales',
  spongeAndFoamSales: 'Sponge and Foam Sales',
  carWashMachineAndEquipmentSales: 'Car Wash Machine and Equipment Sales',
  packagingIndustry: 'Packaging Industry',
  polystyrenePackaging: 'Polystyrene Packaging',
  polystyrene: 'Polystyrene',
  cardboardBoxProduction: 'Cardboard Box Production',
  cardboardTube: 'Cardboard Tube',
  cardboardBoxSales: 'Cardboard Box Sales',
  packagingServices: 'Packaging Services',
  cardboardBoxesSales: 'Cardboard Boxes Sales',
  cardboardBoxesProduction: 'Cardboard Boxes Production',
  plasticCardboard: 'Plastic Cardboard',
  shrinkWrapEquipment: 'Shrink Wrap Equipment',
  packagingSuppliesSales: 'Packaging Supplies Sales',
  packagingSuppliesProduction: 'Packaging Supplies Production',
  fruitBox: 'Fruit Box',
  metalBox: 'Metal Box',
  plasticVacuum: 'Plastic Vacuum',
  ropeAndTwine: 'Rope and Twine',
  adhesiveTape: 'Adhesive Tape',
  metalsIndustry: 'Metals Industry',
  ironSales: 'Iron Sales',
  steelAlloy: 'Steel Alloy',
  industrialAndMetalSheet: 'Industrial and Metal Sheet',
  metalProfile: 'Metal Profile',
  nonMetallicMineral: 'Non-Metallic Mineral',
  nonFerrousAlloy: 'Non-Ferrous Alloy',
  ironProduction: 'Iron Production',
  industrialRebar: 'Industrial Rebar',
  wireDrawing: 'Wire Drawing',
  aluminumProducts: 'Aluminum Products',
  aluminumIngot: 'Aluminum Ingot',
  aluminumFoil: 'Aluminum Foil',
  castPartsProduction: 'Cast Parts Production',
  soldering: 'Soldering',
  metalWire: 'Metal Wire',
  metalBarrel: 'Metal Barrel',
  metalRod: 'Metal Rod',
  metalIndustries: 'Metal Industries',
  copperSales: 'Copper Sales',
  bronze: 'Bronze',
  castIronIngot: 'Cast Iron Ingot',
  zincIngot: 'Zinc Ingot',
  metalSheet: 'Metal Sheet',
  steelParts: 'Steel Parts',
  copperWire: 'Copper Wire',
  nonFerrousMetals: 'Non-Ferrous Metals',
  powderParts: 'Powder Parts',
  metalMesh: 'Metal Mesh',
  metalCan: 'Metal Can',
  steelMesh: 'Steel Mesh',
  moldings: 'Moldings',
  plasticSheetAndPipe: 'Plastic Sheet and Pipe',
  rubberSheet: 'Rubber Sheet',
  steelSheet: 'Steel Sheet',
  pvcPlasticSheet: 'PVC Plastic Sheet',
  polymerSheet: 'Polymer Sheet',
  aluminumSheet: 'Aluminum Sheet',
  ironProfile: 'Iron Profile',
  aluminumProfile: 'Aluminum Profile',
  wireRope: 'Wire Rope',
  barbedWireAndMeshWire: 'Barbed Wire and Mesh Wire',
  copperRolling: 'Copper Rolling',
  leadProduction: 'Lead Production',
  metalIndustryServices: 'Metal Industry Services',
  metalTurning: 'Metal Turning',
  metalBending: 'Metal Bending',
  plasticPlating: 'Plastic Plating',
  metalGlazing: 'Metal Glazing',
  metalPlating: 'Metal Plating',
  aluminumPlating: 'Aluminum Plating',
  platingEquipment: 'Plating Equipment',
  industrialPartsTurning: 'Industrial Parts Turning',
  valveTurning: 'Valve Turning',
  turningAndMoldMaking: 'Turning and Mold Making',
  seriesTurning: 'Series Turning',
  aluminumCasting: 'Aluminum Casting',
  plasticWelding: 'Plastic Welding',
  mirrorAndCandlestickBending: 'Mirror and Candlestick Bending',
  sheetCuttingAndBending: 'Sheet Cutting and Bending',
  ironAndSteelCutting: 'Iron and Steel Cutting',
  waterJet: 'Water Jet',
  industrialBrushProduction: 'Industrial Brush Production',
  hydraulicPress: 'Hydraulic Press',
  milling: 'Milling',
  finishing: 'Finishing',
  pressing: 'Pressing',
  bending: 'Bending',
  blacksmithing: 'Blacksmithing',
  plating: 'Plating',
  smeltingAndRolling: 'Smelting and Rolling',
  hardening: 'Hardening',
  metalCasting: 'Metal Casting',
  weldTest: 'Weld Test',
  welding: 'Welding',
  metalCutting: 'Metal Cutting',
  impactPress: 'Impact Press',
  goldMaking: 'Gold Making',
  industrialForging: 'Industrial Forging',
  goldAndJewelryDesign: 'Gold and Jewelry Design',
  metalDetectorProductionAndSales: 'Metal Detector Production and Sales',
  engineeringAndTechnicalServices: 'Engineering and Technical Services',
  technicalAndEngineeringServices: 'Technical and Engineering Services',
  blueprintProduction: 'Blueprint Production',
  trackingSystemAndGpsSales: 'Tracking System and GPS Sales',
  surveyingEquipmentSales: 'Surveying Equipment Sales',
  surveyingTheodolite: 'Surveying Theodolite',
  satelliteSurveying: 'Satellite Surveying',
  geology: 'Geology',
  geographicInformation: 'Geographic Information',
  agriculturalConsultingEngineers: 'Agricultural Consulting Engineers',
  constructionConsultingEngineers: 'Construction Consulting Engineers',
  facilityConsultingEngineers: 'Facility Consulting Engineers',
  consultingEngineers: 'Consulting Engineers',
  mechanicalEngineering: 'Mechanical Engineering',
  hydraulicAndPneumaticEngineering: 'Hydraulic and Pneumatic Engineering',
  miningEngineering: 'Mining Engineering',
  surveyingConsultingEngineers: 'Surveying Consulting Engineers',
  electricalConsultingEngineer: 'Electrical Consulting Engineer',
  computerConsultingEngineers: 'Computer Consulting Engineers',
  waterResourcesConsultingEngineers: 'Water Resources Consulting Engineers',
  buildingEngineers: 'Building Engineers',
  textileConsultingEngineers: 'Textile Consulting Engineers',
  facilityEngineering: 'Facility Engineering',
  electronicsAndTelecommunicationsConsultingEngineers:
    'Electronics and Telecommunications Consulting Engineers',
  technicalAndEngineeringLaboratoryEquipment:
    'Technical and Engineering Laboratory Equipment',
  nonDestructiveTestingEquipmentAndSupplies:
    'Non-Destructive Testing Equipment and Supplies',
  trackingSystemAndGpsProduction: 'Tracking System and GPS Production',
  surveyingEquipmentProduction: 'Surveying Equipment Production',
  plcProgramming: 'PLC Programming',
  engineeringGroup: 'Engineering Group',
  surveying: 'Surveying',
  technicalOffice: 'Technical Office',
  nonDestructiveTesting: 'Non-Destructive Testing (NDT)',
  petrochemical: 'Petrochemical',
  energyOptimization: 'Energy Optimization',
  oilAndPetrochemicalIndustries: 'Oil and Petrochemical Industries',
  oilGasAndPetrochemicalRefineryFittingsProduction:
    'Oil, Gas and Petrochemical Refinery Fittings Production',
  oilGasAndPetrochemicalRefineryFittingsSales:
    'Oil, Gas and Petrochemical Refinery Fittings Sales',
  chemistryLaboratory: 'Chemistry Laboratory',
  industrialNonStickCoatingTeflonAndCeramic:
    'Industrial Non-Stick Coating (Teflon and Ceramic)',
  polymer: 'Polymer',
  polymerLaboratory: 'Polymer Laboratory',
  chemicalAndPetrochemicalIndustries: 'Chemical and Petrochemical Industries',
  oilGasAndPetrochemicalContractor: 'Oil, Gas and Petrochemical Contractor',
  liquefiedGasCylinderProduction: 'Liquefied Gas Cylinder Production',
  liquefiedGasRegulator: 'Liquefied Gas Regulator',
  gasSupplyAndLiquefiedGasEquipment: 'Gas Supply and Liquefied Gas Equipment',
  heliumGas: 'Helium Gas',
  oxygenGasCylinderSaleAndCharging: 'Oxygen Gas Cylinder Sale and Charging',
  liquefiedGasDistribution: 'Liquefied Gas Distribution',
  bitumenProduction: 'Bitumen Production',
  bitumenSales: 'Bitumen Sales',
  oilSalesBranches: 'Oil Sales Branches',
  gasOilDistributionContractor: 'Gas Oil Distribution Contractor',
  oilGasAndPetrochemicalPlantMaintenanceAndRepair:
    'Oil, Gas and Petrochemical Plant Maintenance and Repair',
  oilGasAndPetrochemicalRefineryEquipmentProduction:
    'Oil, Gas and Petrochemical Refinery Equipment Production',
  oilAndGasPipelineDesignAndImplementation:
    'Oil and Gas Pipeline Design and Implementation',
  polymerIndustries: 'Polymer Industries',
  oilGasAndPetrochemicalProjectDesignAndManagement:
    'Oil, Gas and Petrochemical Project Design and Management',
  gasIndustries: 'Gas Industries',
  oilGasAndPetrochemicalRefineryEquipmentSales:
    'Oil, Gas and Petrochemical Refinery Equipment Sales',
  oilGasAndPetrochemicalProductsProduction:
    'Oil, Gas and Petrochemical Products Production',
  oilGasAndPetrochemicalProductsSales:
    'Oil, Gas and Petrochemical Products Sales',
  oilAndGasFieldsExplorationExtractionAndDevelopment:
    'Oil and Gas Fields Exploration, Extraction and Development',
  oilAndPetrochemicalPlantDesignAndConstruction:
    'Oil and Petrochemical Plant Design and Construction',
  oilAndGasPipeStressRelieving: 'Oil and Gas Pipe Stress Relieving',
  plasticPolymer: 'Plastic Polymer',
  machineToolsAndHardware: 'Machine Tools and Hardware',
  industrialToolsSales: 'Industrial Tools Sales',
  glassCuttingToolProduction: 'Glass Cutting Tool Production',
  glassCuttingToolSales: 'Glass Cutting Tool Sales',
  craneRepair: 'Crane Repair',
  dieselPurifierDevice: 'Diesel Purifier Device',
  constructionToolsSales: 'Construction Tools Sales',
  industrialAndAgriculturalMachinerySales:
    'Industrial and Agricultural Machinery Sales',
  oilPurifierDevice: 'Oil Purifier Device',
  stoneCuttingEquipment: 'Stone Cutting Equipment',
  hydraulicAndPneumaticEquipment: 'Hydraulic and Pneumatic Equipment',
  powerToolRepair: 'Power Tool Repair',
  powerToolSales: 'Power Tool Sales',
  powerToolProduction: 'Power Tool Production',
  industrialToolProduction: 'Industrial Tool Production',
  constructionToolProduction: 'Construction Tool Production',
  industrialMachineryAutomation: 'Industrial Machinery Automation',
  precisionInstrumentMechanicalTesting:
    'Precision Instrument Mechanical Testing',
  machineToolTechnicalServices: 'Machine Tool Technical Services',
  industrialMachineryRepair: 'Industrial Machinery Repair',
  industrialAndAgriculturalMachineryProduction:
    'Industrial and Agricultural Machinery Production',
  industrialGear: 'Industrial Gear',
  industrialGearbox: 'Industrial Gearbox',
  rubberLaboratoryEquipment: 'Rubber Laboratory Equipment',
  industrialToolRepair: 'Industrial Tool Repair',
  parkAndAmusementParkEquipment: 'Park and Amusement Park Equipment',
  toolsAndHardwareProduction: 'Tools and Hardware Production',
  blowMoldingPlastic: 'Blow Molding Plastic',
  pumpSales: 'Pump Sales',
  compressorSaleAndRental: 'Compressor Sale and Rental',
  technicalInspection: 'Technical Inspection',
  phototherapyDevice: 'Phototherapy Device',
  airAndLiquidDustFilterBag: 'Air and Liquid Dust Filter Bag',
  pumpProduction: 'Pump Production',
  drillAndElectricBit: 'Drill and Electric Bit',
  weldingTools: 'Welding Tools',
  sawSharpening: 'Saw Sharpening',
  weldingElectrode: 'Welding Electrode',
  weldingMachineAndEquipment: 'Welding Machine and Equipment',
  oxygenGasEquipment: 'Oxygen Gas Equipment',
  gasLeakDetector: 'Gas Leak Detector',
  fixedRotatingAndIndustrialWheel: 'Fixed, Rotating and Industrial Wheel',
  goldMakingTools: 'Gold Making Tools',
  highPressureHose: 'High Pressure Hose',
  electricalAndElectronicsIndustry: 'Electrical and Electronics Industry',
  electricMotorSaleAndRepair: 'Electric Motor Sale and Repair',
  dieselGeneratorGeneratorAndPowerGeneratorSales:
    'Diesel Generator, Generator and Power Generator Sales',
  electricMotorRepair: 'Electric Motor Repair',
  ups: 'UPS',
  electronicCircuitEquipment: 'Electronic Circuit Equipment',
  electronicAndTelecommunicationComponentsAndSystems:
    'Electronic and Telecommunication Components and Systems',
  motorSpeedController: 'Motor Speed Controller',
  amplifierSales: 'Amplifier Sales',
  encryptionAndIdentificationEquipment:
    'Encryption and Identification Equipment',
  busDuctPowerDistributionAndTransmission:
    'Bus Duct Power Distribution and Transmission',
  electronicComponentsProduction: 'Electronic Components Production',
  amplifierProduction: 'Amplifier Production',
  cassetteAndVideoTapeProduction: 'Cassette and Video Tape Production',
  industrialOrBuildingElectricalEquipmentProduction:
    'Industrial or Building Electrical Equipment Production',
  industrialOrBuildingElectricalEquipmentSales:
    'Industrial or Building Electrical Equipment Sales',
  solarPanelProduction: 'Solar Panel Production',
  solarPanelPoleMountDesignAndConstruction:
    'Solar Panel Pole Mount Design and Construction',
  electronicEquipmentProduction: 'Electronic Equipment Production',
  dieselGeneratorGeneratorAndPowerGeneratorProduction:
    'Diesel Generator, Generator and Power Generator Production',
  powerTransmissionTower: 'Power Transmission Tower',
  dieselGeneratorGeneratorAndPowerGeneratorRepair:
    'Diesel Generator, Generator and Power Generator Repair',
  electricalAndElectronicsIndustries: 'Electrical and Electronics Industries',
  electricMotorProduction: 'Electric Motor Production',
  emergencyPower: 'Emergency Power',
  industrialBattery: 'Industrial Battery',
  electronicLightningRod: 'Electronic Lightning Rod',
  industrialMagnet: 'Industrial Magnet',
  electronicSystemProduction: 'Electronic System Production',
  industrialCapacitor: 'Industrial Capacitor',
  powerDistributionAndTransmission: 'Power Distribution and Transmission',
  electronicEquipmentSales: 'Electronic Equipment Sales',
  electronicComponentsRepair: 'Electronic Components Repair',
  electronicsRelatedServices: 'Electronics Related Services',
  electronicComponentsSales: 'Electronic Components Sales',
  barcode: 'Barcode',
  electronicBoardAssembly: 'Electronic Board Assembly',
  solarPanelSales: 'Solar Panel Sales',
  industrialElectricalEquipment: 'Industrial Electrical Equipment',
  switchAndSocketProduction: 'Switch and Socket Production',
  industrialConstruction: 'Industrial Construction',
  damAndCanalConstruction: 'Dam and Canal Construction',
  automaticBarrier: 'Automatic Barrier',
  asphaltPaving: 'Asphalt Paving',
  asphaltSales: 'Asphalt Sales',
  trafficLandscaping: 'Traffic Landscaping',
  pierConstruction: 'Pier Construction',
  bridgeConstruction: 'Bridge Construction',
  airportConstruction: 'Airport Construction',
  refineryConstruction: 'Refinery Construction',
  railwayConstruction: 'Railway Construction',
  tunnelConstruction: 'Tunnel Construction',
  roadAndHighwayConstruction: 'Road and Highway Construction',
  powerPlantConstruction: 'Power Plant Construction',
  industrialDrafting: 'Industrial Drafting',
  marineStructure: 'Marine Structure',
  concretePowerPoleConstruction: 'Concrete Power Pole Construction',
  steelShedAndSkeleton: 'Steel Shed and Skeleton',
  workAtHeight: 'Work at Height',
  beautyProductsAndServices: 'Beauty Products and Services',
  beautyAndCosmeticCenters: 'Beauty and Cosmetic Centers',
  womensHairSalon: "Women's Hair Salon",
  mensHairSalon: "Men's Hair Salon",
  laserHairRemoval: 'Laser Hair Removal',
  solarium: 'Solarium',
  masseur: 'Masseur',
  cosmeticAndHygienicProducts: 'Cosmetic and Hygienic Products',
  cosmeticAndHygienicProductsSales: 'Cosmetic and Hygienic Products Sales',
  cosmeticAndHygienicProductsRawMaterialsProduction:
    'Cosmetic and Hygienic Products Raw Materials Production',
  cosmeticAndHygienicProductsProduction:
    'Cosmetic and Hygienic Products Production',
  cosmeticAndHygienicProductsDistribution:
    'Cosmetic and Hygienic Products Distribution',
  cosmeticAndHygienicProductsPackaging:
    'Cosmetic and Hygienic Products Packaging',
  salonEquipmentAndSupplies: 'Salon Equipment and Supplies',
  detergentIndustry: 'Detergent Industry',
  cleanerAndDetergentSales: 'Cleaner and Detergent Sales',
  cleanerAndDetergentProduction: 'Cleaner and Detergent Production',
  cleanerAndDetergentRawMaterials: 'Cleaner and Detergent Raw Materials',
  industrialCleanerAndDetergent: 'Industrial Cleaner and Detergent',
  cosmeticAndHygienicSuppliesQualityControl:
    'Cosmetic and Hygienic Supplies Quality Control',
  educationAndResearch: 'Education and Research',
  publicSchools: 'Public Schools',
  publicMixedPreSchool: 'Public Mixed Pre-School',
  publicBoysPreSchool: "Public Boys' Pre-School",
  publicGirlsPreSchool: "Public Girls' Pre-School",
  publicBoysElementarySchool: "Public Boys' Elementary School",
  publicGirlsElementarySchool: "Public Girls' Elementary School",
  publicBoysMiddleSchool: "Public Boys' Middle School",
  publicGirlsMiddleSchool: "Public Girls' Middle School",
  publicBoysHighSchool: "Public Boys' High School",
  publicGirlsHighSchool: "Public Girls' High School",
  publicGirlsSacrificeHighSchool: "Public Girls' Sacrifice High School",
  giftedHighSchool: 'Gifted High School',
  publicBoysVocationalTechnicalSchool:
    "Public Boys' Vocational Technical School",
  publicGirlsVocationalTechnicalSchool:
    "Public Girls' Vocational Technical School",
  publicBoysVocationalSchool: "Public Boys' Vocational School",
  publicGirlsVocationalSchool: "Public Girls' Vocational School",
  publicBoysTechnicalSchool: "Public Boys' Technical School",
  publicGirlsTechnicalSchool: "Public Girls' Technical School",
  publicBoysPreUniversity: "Public Boys' Pre-University",
  publicGirlsPreUniversity: "Public Girls' Pre-University",
  publicBoysEducationalComplex: "Public Boys' Educational Complex",
  publicGirlsEducationalComplex: "Public Girls' Educational Complex",
  privateSchools: 'Private Schools',
  kindergartenAndPreparatory: 'Kindergarten and Preparatory',
  privateMixedPreSchool: 'Private Mixed Pre-School',
  privateBoysPreSchool: "Private Boys' Pre-School",
  privateGirlsPreSchool: "Private Girls' Pre-School",
  privateBoysElementarySchool: "Private Boys' Elementary School",
  privateGirlsElementarySchool: "Private Girls' Elementary School",
  privateBoysMiddleSchool: "Private Boys' Middle School",
  privateGirlsMiddleSchool: "Private Girls' Middle School",
  privateBoysHighSchool: "Private Boys' High School",
  privateGirlsHighSchool: "Private Girls' High School",
  privateBoysPreUniversity: "Private Boys' Pre-University",
  privateGirlsPreUniversity: "Private Girls' Pre-University",
  privateBoysVocationalTechnicalSchool:
    "Private Boys' Vocational Technical School",
  privateGirlsVocationalTechnicalSchool:
    "Private Girls' Vocational Technical School",
  privateBoysVocationalSchool: "Private Boys' Vocational School",
  privateGirlsVocationalSchool: "Private Girls' Vocational School",
  privateBoysTechnicalSchool: "Private Boys' Technical School",
  privateGirlsTechnicalSchool: "Private Girls' Technical School",
  privateBoysEducationalComplex: "Private Boys' Educational Complex",
  privateGirlsEducationalComplex: "Private Girls' Educational Complex",
  specialSchools: 'Special Schools',
  rehabilitationCenterForExceptionalChildren:
    'Rehabilitation Center for Exceptional Children',
  exceptionalElementarySchool: 'Exceptional Elementary School',
  exceptionalMiddleSchool: 'Exceptional Middle School',
  exceptionalHighSchool: 'Exceptional High School',
  educationalAndResearchCenters: 'Educational and Research Centers',
  university: 'University',
  motorcycleTrainingCenter: 'Motorcycle Training Center',
  heavyMachineryDrivingSchool: 'Heavy Machinery Driving School',
  distanceLearningSchools: 'Distance Learning Schools',
  moldMakingTraining: 'Mold Making Training',
  knowledgeBased: 'Knowledge-Based',
  scienceAndEntranceExamInstitution: 'Science and Entrance Exam Institution',
  languageSchool: 'Language School',
  drivingSchool: 'Driving School',
  defensiveDrivingTraining: 'Defensive Driving Training',
  computerTraining: 'Computer Training',
  medicinalPlantsTraining: 'Medicinal Plants Training',
  educationalResearchInstitute: 'Educational Research Institute',
  medicalResearchCenter: 'Medical Research Center',
  researchAndInformation: 'Research and Information',
  mobileRepairTraining: 'Mobile Repair Training',
  hotelManagementTraining: 'Hotel Management Training',
  tourismServicesTrainingCenter: 'Tourism Services Training Center',
  quranEducation: 'Quran Education',
  biochemistry: 'Biochemistry',
  typingTraining: 'Typing Training',
  accountingAndAuditingTraining: 'Accounting and Auditing Training',
  onlineTraining: 'Online Training',
  electronicEquipmentRepairTraining: 'Electronic Equipment Repair Training',
  slacklineTraining: 'Slackline Training',
  astronomyTraining: 'Astronomy Training',
  guildHealthTrainingCenter: 'Guild Health Training Center',
  alphabetTraining: 'Alphabet Training',
  seminaryForBrothers: 'Seminary for Brothers',
  seminaryForSisters: 'Seminary for Sisters',
  medicalEquipmentRepairTraining: 'Medical Equipment Repair Training',
  childrenLanguageSchool: "Children's Language School",
  petTraining: 'Pet Training',
  educationalServices: 'Educational Services',
  spanishLanguageInstructor: 'Spanish Language Instructor',
  privateTutoring: 'Private Tutoring',
  educationalAndEntranceExamConsulting:
    'Educational and Entrance Exam Consulting',
  schoolSmartening: 'School Smartening',
  educationalSpaceRental: 'Educational Space Rental',
  educationalAidsEquipment: 'Educational Aids Equipment',
  stationerySales: 'Stationery Sales',
  technicalAndVocationalTrainingCenters:
    'Technical and Vocational Training Centers',
  photographyTraining: 'Photography Training',
  cookingTraining: 'Cooking Training',
  calligraphyTraining: 'Calligraphy Training',
  womensTailoringTraining: "Women's Tailoring Training",
  technicalAndVocationalTrainingCenter:
    'Technical and Vocational Training Center',
  mensTailoringTraining: "Men's Tailoring Training",
  weavingTrainingCenter: 'Weaving Training Center',
  womensHairdressingTraining: "Women's Hairdressing Training",
  mensHairdressingTraining: "Men's Hairdressing Training",
  actingAndMakeupTraining: 'Acting and Makeup Training',
  sewingAndEmbroideryTraining: 'Sewing and Embroidery Training',
  artInstitute: 'Art Institute',
  carpetWeavingTraining: 'Carpet Weaving Training',
  goldMakingTraining: 'Gold Making Training',
  paintingTraining: 'Painting Training',
  bagShoeAndBeltMakingTraining: 'Bag, Shoe and Belt Making Training',
  flowerMakingAndFloristryTraining: 'Flower Making and Floristry Training',
  speedReadingAndLearningTraining: 'Speed Reading and Learning Training',
  draftingTraining: 'Drafting Training',
  designAndArchitectureTraining: 'Design and Architecture Training',
  toys: 'Toys',
  toysSales: 'Toys Sales',
  rechargeableCarRepair: 'Rechargeable Car Repair',
  dollSales: 'Doll Sales',
  balloonSales: 'Balloon Sales',
  toyRepair: 'Toy Repair',
  rechargeableCar: 'Rechargeable Car',
  rechargeableMotorcycle: 'Rechargeable Motorcycle',
  sportsTrainingCenters: 'Sports Training Centers',
  volleyballTraining: 'Volleyball Training',
  swimmingTraining: 'Swimming Training',
  flightTraining: 'Flight Training',
  divingTraining: 'Diving Training',
  skateTraining: 'Skate Training',
  skiTraining: 'Ski Training',
  tennisTraining: 'Tennis Training',
  selfDefenseTraining: 'Self-Defense Training',
  electronicsAndDigital: 'Electronics and Digital',
  digitalGoods: 'Digital Goods',
  mobilePhoneSaleAndRepair: 'Mobile Phone Sale and Repair',
  simCardSales: 'SIM Card Sales',
  laptopSales: 'Laptop Sales',
  computerHardwareComponentsSales: 'Computer Hardware Components Sales',
  computerPeripheralsSales: 'Computer Peripherals Sales',
  officeMachinerySales: 'Office Machinery Sales',
  cameraAndPhotographyEquipmentSaleAndRepair:
    'Camera and Photography Equipment Sale and Repair',
  photographyEquipmentSales: 'Photography Equipment Sales',
  playstationAndGameConsoleSales: 'PlayStation and Game Console Sales',
  softwareAndGameCdSales: 'Software and Game CD Sales',
  softwareSales: 'Software Sales',
  cassetteAndVideoTapeSales: 'Cassette and Video Tape Sales',
  mobilePhoneProduction: 'Mobile Phone Production',
  mobilePhoneAccessories: 'Mobile Phone Accessories',
  officeMachineryProduction: 'Office Machinery Production',
  officeMachinerySupplies: 'Office Machinery Supplies',
  officeMachineryRepair: 'Office Machinery Repair',
  laptopRepair: 'Laptop Repair',
  photographyEquipmentProduction: 'Photography Equipment Production',
  playstationAndGameConsoleRepair: 'PlayStation and Game Console Repair',
  computerPeripheralEquipmentRepair: 'Computer Peripheral Equipment Repair',
  softwareDistribution: 'Software Distribution',
  electronicsAndDigitalServices: 'Electronics and Digital Services',
  computerServices: 'Computer Services',
  medicalSoftware: 'Medical Software',
  internetCafe: 'Internet Cafe',
  websiteDesign: 'Website Design',
  domainRegistrationAndWebHosting: 'Domain Registration and Web Hosting',
  programming: 'Programming',
  onlineStore: 'Online Store',
  communicationServicesCenter: 'Communication Services Center',
  internetAccessServicesIsp: 'Internet Access Services (ISP)',
  networkingServices: 'Networking Services',
  networkEquipmentSales: 'Network Equipment Sales',
  networkEquipmentProduction: 'Network Equipment Production',
  computerHardwareComponentsProduction:
    'Computer Hardware Components Production',
  computerHardwareComponentsRepair: 'Computer Hardware Components Repair',
  telecommunicationCenter: 'Telecommunication Center',
  telecommunicationEquipmentSaleAndInstallation:
    'Telecommunication Equipment Sale and Installation',
  telecommunicationEquipmentProduction:
    'Telecommunication Equipment Production',
  telephoneAndTelecommunicationEquipmentRepair:
    'Telephone and Telecommunication Equipment Repair',
  managementInformationSystem: 'Management Information System (MIS)',
  computerGameDesignAndProduction: 'Computer Game Design and Production',
  electronicEquipmentRepair: 'Electronic Equipment Repair',
  electricalAppliancesSaleAndRepair: 'Electrical Appliances Sale and Repair',
  electricalAppliancesProductionAndDistribution:
    'Electrical Appliances Production and Distribution',
  virtualOfficeOffice: 'Virtual Office',
  cdServices: 'CD Services',
  hardwareLock: 'Hardware Lock',
  softwareLock: 'Software Lock',
  transportation: 'Transportation',
  transportationServices: 'Transportation Services',
  internationalTransportation: 'International Transportation',
  wagonManufacturing: 'Wagon Manufacturing',
  railwayEquipment: 'Railway Equipment',
  maritimeTransport: 'Maritime Transport',
  fluidMaterialsTransport: 'Fluid Materials Transport',
  livestockAndPoultryTransport: 'Livestock and Poultry Transport',
  cementTransport: 'Cement Transport',
  craneTransport: 'Crane Transport',
  trailerTransport: 'Trailer Transport',
  cargoTransport: 'Cargo Transport',
  agencyAndPostOffice: 'Agency and Post Office',
  intelligentTransportationSystem: 'Intelligent Transportation System',
  cargoTerminal: 'Cargo Terminal',
  maritimeServices: 'Maritime Services',
  metroServices: 'Metro Services',
  parking: 'Parking',
  transportationVehicles: 'Transportation Vehicles',
  landTransport: 'Land Transport',
  railwayStation: 'Railway Station',
  brtStation: 'BRT Station',
  busStation: 'Bus Station',
  intraCityBusTerminal: 'Intra-City Bus Terminal',
  metroStation: 'Metro Station',
  taxiService: 'Taxi Service',
  taxiTerminal: 'Taxi Terminal',
  carRental: 'Car Rental',
  busAndMinibusRental: 'Bus and Minibus Rental',
  motorcycleCourier: 'Motorcycle Courier',
  internetTaxi: 'Internet Taxi',
  airTransport: 'Air Transport',
  airlines: 'Airlines',
  airport: 'Airport',
  shipping: 'Shipping',
  passengerPort: 'Passenger Port',
  travelAndTourism: 'Travel and Tourism',
  accommodation: 'Accommodation',
  ecotourism: 'Ecotourism',
  hotel: 'Hotel',
  suiteVilla: 'Suite Villa',
  apartmentHotel: 'Apartment Hotel',
  guestHouse: 'Guest House',
  guesthouseAndPension: 'Guesthouse and Pension',
  inn: 'Inn',
  teacherHouseAndWelfareCenter: 'Teacher House and Welfare Center',
  studentDormitory: 'Student Dormitory',
  travelServices: 'Travel Services',
  passengerTransportCompany: 'Passenger Transport Company',
  travelAgency: 'Travel Agency',
  airlineAgency: 'Airline Agency',
  immigrationServices: 'Immigration Services',
  handicraftsSales: 'Handicrafts Sales',
  handicraftsProduction: 'Handicrafts Production',
  railway: 'Railway',
  travelTerminal: 'Travel Terminal',
  welfareComplex: 'Welfare Complex',
  recreationalPlaces: 'Recreational Places',
  culturalSportsRecreationalComplex: 'Cultural, Sports, Recreational Complex',
  amusementPark: 'Amusement Park',
  park: 'Park',
  recreationalCenters: 'Recreational Centers',
  mineralSpring: 'Mineral Spring',
  lake: 'Lake',
  zoo: 'Zoo',
  gameNet: 'Game Net',
  sightseeingPlaces: 'Sightseeing Places',
  ancientMonumentsAndHistoricalBuildings:
    'Ancient Monuments and Historical Buildings',
  palace: 'Palace',
  museum: 'Museum',
  mosque: 'Mosque',
  hussainiaAndTekyeh: 'Hussainia and Tekyeh',
  imamzadehAndPilgrimageSite: 'Imamzadeh and Pilgrimage Site',
  synagogue: 'Synagogue',
  church: 'Church',
  printingAndAdvertising: 'Printing and Advertising',
  printingAndPublishing: 'Printing and Publishing',
  silkScreen: 'Silk Screen',
  printingHouse: 'Printing House',
  bookbinding: 'Bookbinding',
  lithography: 'Lithography',
  plotterAndColorPrint: 'Plotter and Color Print',
  designAndPrint: 'Design and Print',
  typesettingAndTyping: 'Typesetting and Typing',
  notebookMaking: 'Notebook Making',
  embossing: 'Embossing',
  envelopeMaking: 'Envelope Making',
  bookDistribution: 'Book Distribution',
  paperCutting: 'Paper Cutting',
  envelopeSales: 'Envelope Sales',
  publications: 'Publications',
  periodical: 'Periodical',
  printingAndPublishingSupplies: 'Printing and Publishing Supplies',
  bookstore: 'Bookstore',
  paperAndCardboardSales: 'Paper and Cardboard Sales',
  paperAndCardboardRawMaterials: 'Paper and Cardboard Raw Materials',
  paperAndCardboardProduction: 'Paper and Cardboard Production',
  poster: 'Poster',
  envelopeProduction: 'Envelope Production',
  photostatProduction: 'Photostat Production',
  sticker: 'Sticker',
  hologram: 'Hologram',
  flag: 'Flag',
  advertising: 'Advertising',
  contentProduction: 'Content Production',
  advertisingAgencyAndCompany: 'Advertising Agency and Company',
  statuette: 'Statuette',
  advertisingBoard: 'Advertising Board',
  promotionalGift: 'Promotional Gift',
  advertisingTeaserProduction: 'Advertising Teaser Production',
  exhibitionBoothDesignAndImplementation:
    'Exhibition Booth Design and Implementation',
  computerDesignAndAnimation: 'Computer Design and Animation',
  industrialPhotography: 'Industrial Photography',
  publicationAdvertisementAcceptanceAgency:
    'Publication Advertisement Acceptance Agency',
  information: 'Information',
  graphicDesign: 'Graphic Design',
  graphicDesigner: 'Graphic Designer',
  filmMaking: 'Film Making',
  advertisingTeaserNarrator: 'Advertising Teaser Narrator',
  smsValueAddedService: 'SMS Value-Added Service',
  hiringAdvertisingConsultant: 'Hiring Advertising Consultant',
  stampAndLicensePlate: 'Stamp and License Plate',
  shoppingBag: 'Shopping Bag',
  marketing: 'Marketing',
  sportsCultureArt: 'Sports, Culture, Art',
  cultureAndArt: 'Culture and Art',
  library: 'Library',
  cinema: 'Cinema',
  theater: 'Theater',
  culturalCenter: 'Cultural Center',
  artGallery: 'Art Gallery',
  musicalInstrumentSales: 'Musical Instrument Sales',
  musicSchool: 'Music School',
  paintingGallery: 'Painting Gallery',
  cultureHouse: 'Culture House',
  culturalInstitute: 'Cultural Institute',
  storytellingAndPardeKhani: 'Storytelling and Parde Khani',
  theaterGroup: 'Theater Group',
  painting: 'Painting',
  newspaperAgency: 'Newspaper Agency',
  videoClub: 'Video Club',
  visualArts: 'Visual Arts',
  soundRecordingAndDubbingStudio: 'Sound Recording and Dubbing Studio',
  filmingOrDubbingStudio: 'Filming or Dubbing Studio',
  artSupplies: 'Art Supplies',
  flowerMakingAndFloristry: 'Flower Making and Floristry',
  socialClub: 'Social Club',
  culturalAndArtConsulting: 'Cultural and Art Consulting',
  audioBook: 'Audio Book',
  performingArts: 'Performing Arts',
  sports: 'Sports',
  sportsClub: 'Sports Club',
  sportsCoach: 'Sports Coach',
  footballClub: 'Football Club',
  bodybuildingClub: 'Bodybuilding Club',
  aerobicsClub: 'Aerobics Club',
  martialArtsClub: 'Martial Arts Club',
  billiardClub: 'Billiard Club',
  tennisClub: 'Tennis Club',
  equestrianClub: 'Equestrian Club',
  swimmingPoolAndSauna: 'Swimming Pool and Sauna',
  stadium: 'Stadium',
  yoga: 'Yoga',
  paintball: 'Paintball',
  athlete: 'Athlete',
  sportsEquipmentAndSupplies: 'Sports Equipment and Supplies',
  sportsMat: 'Sports Mat',
  proteinPowderSales: 'Protein Powder Sales',
  fishingSupplies: 'Fishing Supplies',
  huntingSupplies: 'Hunting Supplies',
  mountaineeringSupplies: 'Mountaineering Supplies',
  aviationSupplies: 'Aviation Supplies',
  sportsHallEquipment: 'Sports Hall Equipment',
  medicalSportsEquipmentSales: 'Medical Sports Equipment Sales',
  vehiclesAndTransportation: 'Vehicles and Transportation',
  passengerCar: 'Passenger Car',
  carShowroom: 'Car Showroom',
  carBatteryProduction: 'Car Battery Production',
  carBearingAndBallBearingProduction: 'Car Bearing and Ball Bearing Production',
  shotProduction: 'Shot Production',
  shotSales: 'Shot Sales',
  carBuyingAndSelling: 'Car Buying and Selling',
  autoSparePartsSales: 'Auto Spare Parts Sales',
  carRimAndTireSales: 'Car Rim and Tire Sales',
  carRepairAndTuneUpShop: 'Car Repair and Tune-up Shop',
  carBatteryAndElectrical: 'Car Battery and Electrical',
  carManufacturing: 'Car Manufacturing',
  autoSparePartsProduction: 'Auto Spare Parts Production',
  autoSparePartsDistribution: 'Auto Spare Parts Distribution',
  carLeasing: 'Car Leasing',
  motorcycleAndBicycle: 'Motorcycle and Bicycle',
  motorcycleSales: 'Motorcycle Sales',
  motorcycleSparePartsSales: 'Motorcycle Spare Parts Sales',
  bicycleSales: 'Bicycle Sales',
  motorcycleAndBicycleSparePartsSales:
    'Motorcycle and Bicycle Spare Parts Sales',
  motorcycleAgency: 'Motorcycle Agency',
  authorizedMotorcycleRepairShop: 'Authorized Motorcycle Repair Shop',
  motorcycleAndBicycleRepair: 'Motorcycle and Bicycle Repair',
  motorcycleProduction: 'Motorcycle Production',
  bicycleProduction: 'Bicycle Production',
  motorcycleSparePartsProduction: 'Motorcycle Spare Parts Production',
  heavyVehicles: 'Heavy Vehicles',
  heavyVehiclesSales: 'Heavy Vehicles Sales',
  heavyMachinerySparePartsSales: 'Heavy Machinery Spare Parts Sales',
  heavyMachineryRental: 'Heavy Machinery Rental',
  heavyVehiclesSpareParts: 'Heavy Vehicles Spare Parts',
  heavyVehiclesRepairAndAfterSalesServices:
    'Heavy Vehicles Repair and After-Sales Services',
  heavyVehiclesProduction: 'Heavy Vehicles Production',
  transportationVehiclesServices: 'Transportation Vehicles Services',
  authorizedCarDealer: 'Authorized Car Dealer',
  roadsideAssistance: 'Roadside Assistance',
  vehicleTechnicalInspectionCenters: 'Vehicle Technical Inspection Centers',
  carLicensePlateReplacement: 'Car License Plate Replacement',
  carWash: 'Car Wash',
  roundTheClockCarWash: '24-Hour Car Wash',
  gasStation: 'Gas Station',
  gasPump: 'Gas Pump',
  carAccessories: 'Car Accessories',
  fiberglassServices: 'Fiberglass Services',
  carGasConversion: 'Car Gas Conversion',
  trafficSigns: 'Traffic Signs',
  carBodyBuilding: 'Car Body Building',
  damagedCarSales: 'Damaged Car Sales',
  carPaint: 'Car Paint',
  carExpert: 'Car Expert',
  agricultureAndLivestock: 'Agriculture and Livestock',
  agriculture: 'Agriculture',
  greenhouseEquipment: 'Greenhouse Equipment',
  agriculturalAndGardeningEquipment: 'Agricultural and Gardening Equipment',
  agriculturalServices: 'Agricultural Services',
  soilScienceLaboratory: 'Soil Science Laboratory',
  greenhouseAndPlantCultivation: 'Greenhouse and Plant Cultivation',
  agriculturalProducts: 'Agricultural Products',
  agroIndustry: 'Agro-Industry',
  agriculturalMachinerySales: 'Agricultural Machinery Sales',
  watershedManagement: 'Watershed Management',
  animalHusbandry: 'Animal Husbandry',
  livestockFarming: 'Livestock Farming',
  herbalMedicineForLivestockAndPoultryProduction:
    'Herbal Medicine for Livestock and Poultry Production',
  livestockPoultryAndAquaticsFeedSales:
    'Livestock, Poultry and Aquatics Feed Sales',
  fisheries: 'Fisheries',
  poultryFarming: 'Poultry Farming',
  livestockAndPoultryLaboratory: 'Livestock and Poultry Laboratory',
  petBoarding: 'Pet Boarding',
  slaughterhouse: 'Slaughterhouse',
  dogBreeding: 'Dog Breeding',
  importAndExportOfCCTVEquipment: 'Import and export of CCTV equipment',
};
